import React, { useEffect, useRef, useState } from 'react';

interface ProgressCircleProps {
  progress: number;
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({ progress }) => {
  const circumference = 243.4;
  const [animatedProgress, setAnimatedProgress] = useState(0);
  const prevProgressRef = useRef(0);

  useEffect(() => {
    const prevProgress = prevProgressRef.current;
    prevProgressRef.current = progress;
    
    const animationDuration = 500;
    const startTime = Date.now();
    
    const animateProgress = () => {
      const elapsedTime = Date.now() - startTime;
      const progressRatio = Math.min(elapsedTime / animationDuration, 1);
      
      const easeOutValue = 1 - (1 - progressRatio) * (1 - progressRatio);
      const currentProgress = prevProgress + (progress - prevProgress) * easeOutValue;
      
      setAnimatedProgress(currentProgress);
      
      if (progressRatio < 1) {
        requestAnimationFrame(animateProgress);
      }
    };
    
    animateProgress();
  }, [progress]);

  return (
    <svg
      className="w-full h-full"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84 84"
      fill="none"
    >
     <circle cx="42.2498" cy="42.2411" r="41.7411" fill="black" fillOpacity="0.5" />
      
      <circle
        cx="42.2498"
        cy="42.2411"
        r="38.7411"
        fill="transparent"
        stroke="white"
        strokeWidth="6"
        strokeDasharray={circumference}
        strokeDashoffset={circumference - (circumference * animatedProgress) / 100}
        transform="rotate(-90 42.2498 42.2411)"
      />
      
      <text
        x="42.2498"
        y="47"
        textAnchor="middle"
        fill="white"
        fontSize="20"
        fontWeight="bold"
      >
        {Math.round(animatedProgress)}%
      </text>
    </svg>
  );
};

export default ProgressCircle;